import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export default function AnnouncementBar({ visible, onClose }) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="announcement-bar"
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed top-0 left-0 right-0 z-[60] h-10 flex items-center justify-center bg-[#d4af37] text-black"
        >
          <div className="flex items-center gap-2.5 text-xs sm:text-sm font-medium tracking-wide">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-black/50" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-black" />
            </span>
            <span data-testid="availability-text">
              Currently booking <strong>2 projects</strong> this month — limited availability
            </span>
          </div>
          <button
            data-testid="announcement-close"
            onClick={onClose}
            aria-label="Dismiss announcement"
            className="absolute right-4 text-black/60 hover:text-black transition-colors"
          >
            <X size={16} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
